var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar",
      style: _vm.sidebarStyle,
      attrs: {
        "data-color": _vm.backgroundColor,
        "data-image": _vm.backgroundImage
      }
    },
    [
      _c(
        "div",
        { staticClass: "sidebar-wrapper" },
        [
          _c(
            "div",
            { staticClass: "logo" },
            [
              _c(
                "router-link",
                { staticClass: "simple-text text-center", attrs: { to: "/" } },
                [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "nav" },
            [
              _vm._t("default", function() {
                return _vm._l(_vm.sidebarLinks, function(link, index) {
                  return _c(
                    "sidebar-link",
                    {
                      key: link.name + index,
                      attrs: { to: link.path, link: link },
                      on: { click: _vm.closeNavbar }
                    },
                    [
                      _c("i", { class: link.icon }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(link.name))])
                    ]
                  )
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("content")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7db87da7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7db87da7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/SidebarPlugin/SideBar.vue
// module id = 4XVn
// module chunks = 0